import { render, staticRenderFns } from "./xiangce.vue?vue&type=template&id=56b404e6&scoped=true"
import script from "./xiangce.vue?vue&type=script&lang=js"
export * from "./xiangce.vue?vue&type=script&lang=js"
import style0 from "./xiangce.vue?vue&type=style&index=0&id=56b404e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b404e6",
  null
  
)

export default component.exports